module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "conteudo tela-login"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("SSP Módulo Financeiro")]), _vm._v(" "), (_vm.show) ? _c('b-form', {
    staticClass: "login"
  }, [_c('b-form-group', {
    attrs: {
      "id": "input-group-1",
      "label": "Digite seu endereço de e-mail:",
      "label-for": "input-1",
      "description": ""
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "input-1",
      "type": "email",
      "required": "",
      "placeholder": "Digite aqui seu e-mail"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "id": "input-group-1",
      "label": "Senha:",
      "label-for": "input-2",
      "description": ""
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "input-2",
      "type": "password",
      "required": "",
      "placeholder": "Digite sua senha"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ms-cadastro"
  }, [_c('div', [_c('p', [_c('a', {
    attrs: {
      "href": ((_vm.env.CADASTRO_USUARIO) + "/reset")
    }
  }, [_vm._v("Esqueci a senha.")])])])]), _vm._v(" "), _c('div', [_c('b-button', {
    attrs: {
      "type": "button",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit()
      }
    }
  }, [_vm._v("Entrar")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "indentificacao-ambiente"
  }, [_c('small', [_vm._v(_vm._s(_vm.env.NODE_ENV) + " v1")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65c78a5b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loginLogout/Login.vue
// module id = 997
// module chunks = 1